/* eslint-disable @typescript-eslint/naming-convention */
export const MSAL_CLIENT_ID = `${process.env.REACT_APP_MSAL_CLIENTID}`;
export const MSAL_AUTHORITY = `${process.env.REACT_APP_MSAL_AUTHORITY}`;
export const MSAL_READ_SCOPE = `${process.env.REACT_APP_READ_SCOPE}`;
export const MSAL_WRITE_SCOPE = `${process.env.REACT_APP_WRITE_SCOPE}`;
export const AI_INSTRUMENTATION_KEY = `${process.env.REACT_APP_AI_INSTRUMENTATION_KEY}`;
export const MUI_LICENSE_KEY = `${process.env.REACT_APP_MUI_LICENSE_KEY}`;
export const APTEAN_API_SUBSCRIPTION_KEY = `${process.env.REACT_APP_APTEAN_API_SUBSCRIPTION_KEY}`;
